var animationDurationVar = 'var(--fx_e395032e_1mjtb9o1)';
var animationNameVar = 'var(--fx_e395032e_1mjtb9o0)';
var animationTimingFunctionVar = 'var(--fx_e395032e_1mjtb9o2)';
var root = 'fx_e395032e_1mjtb9o3';

export { animationDurationVar, animationNameVar, animationTimingFunctionVar, root };
//# sourceMappingURL=animationController.vanilla.mjs.map
